
import React                 from 'react';
import { observer, inject  } from 'mobx-react';

import { Menu              } from './commun/Menu';
import { BandeauSmartphone } from './commun/BandeauSmartphone';

/* *********************************************************************************** */
/* **********                                                               ********** */
/* **********                          ContactSmartphone                    ********** */
/* **********                                                               ********** */
/* *********************************************************************************** */

export const ContactSmartphone = inject(['store'])(observer(class ContactSmartphone extends React.Component {

  /* ---------------------- */
  /* Affichage du composant */
  /* ---------------------- */

  render() {

    /* ------------------------------ */
    /* Définition des CSS d'affichage */
    /* ------------------------------ */

    const styleBlocTexte = {
        width        : (window.innerWidth - 20) + "px",
        display      : "block",
        marginTop    : "20px",
        marginBottom : "10px"
    };

    /* ----------------------------------------- */
    /* Définition de l'onglet du menu à afficher */
    /* ----------------------------------------- */

    this.props.store.definirSelectionOnglet ("contact");

    /* ------------------------------- */
    /* Définition du titre de l'onglet */
    /* ------------------------------- */

    document.title = "Contact - La geste d'Aros";

    /* -------------------------------- */
    /* Formatage des données à afficher */
    /* -------------------------------- */

    /* ------------------- */
    /* Renvoi du composant */
    /* ------------------- */

    return (

        <div id='divContactSmartphone' style={{textAlign:'center'}}> 

              <BandeauSmartphone />

              <Menu menu = {this.props.store.menu} />

              <div style={styleBlocTexte}>  

                  <p className="Recit">
                      Au vu du nombre colossal de volumes lus et/ou vendus à ce jour (que j'estime au mieux à 50 exemplaires), je doute d'être submergé par des torrents de mails, qu'ils proviennent de fans enthousiastes ou de critiques négatives particulièrement acerbes.
                  </p>
                  <p className="Recit">
                      Néanmoins, la simple politesse et la structure des sites actuels m'enjoignent de permettre à tout un chacun d'exprimer ses remarques, demandes et autres suggestions (voire compliments) concernant cette belle (si, si, ne discutez pas !!!) saga.
                  </p>
                  <p className="Recit">
                      Pour toutes ces personnes, et aussi pour les autres, vous pouvez envoyer un mail à : <a href='mailto:geste.aros@gmail.com' target='_blank' rel="noopener noreferrer">geste.aros@gmail.com</a>
                  </p>

             </div>

        </div>
      )
    } 
  } // Fin de la classe ContactSmartphone
))



// WEBPACK FOOTER //
// ./src/components/ContactSmartphone.js